<template>
  <path
    d="M6 19.0002C6 20.1002 6.9 21.0002 8 21.0002H16C17.1 21.0002 18 20.1002 18 19.0002V9.00018C18 7.90018 17.1 7.00018 16 7.00018H8C6.9 7.00018 6 7.90018 6 9.00018V19.0002ZM18 4.00018H15.5L14.79 3.29018C14.61 3.11018 14.35 3.00018 14.09 3.00018H9.91C9.65 3.00018 9.39 3.11018 9.21 3.29018L8.5 4.00018H6C5.45 4.00018 5 4.45018 5 5.00018C5 5.55018 5.45 6.00018 6 6.00018H18C18.55 6.00018 19 5.55018 19 5.00018C19 4.45018 18.55 4.00018 18 4.00018Z"
  />
</template>
